
import { IUserDto, getDisplayName } from "moo-shared";
import { isDefined } from "../helpers";
import { ITile } from "./tile.model";

export class UserTile implements ITile {
  constructor(
    public key: string,
    public firstName: string = "",
    public loginName: string = "",
    public middleName: string = "",
    public lastName: string = "",
    public picture: string = "",
    public defaultImage: string = "./assets/images/icon_user.svg",
    public defaultImageClass: string = "blue-background"

  ) { }
  get name(): string {
    return getDisplayName(this.firstName, this.middleName, this.lastName);
  }

  static fromDto(value: IUserDto) {
    const midlleName = isDefined(value.MiddleName) ? value.MiddleName : "";
    const lastName = isDefined(value.LastName) ? value.LastName : "";
    const firstName = isDefined(value.FirstName) ? value.FirstName : "";
    return new UserTile(
      value.Key,
      firstName,
      value.LoginName,
      midlleName,
      lastName
    );
  }

  static fromDtoMasked(value: IUserDto) {
    const userTile = this.fromDto(value);
    userTile.middleName = "";
    userTile.lastName = value.LastName ? `${value.LastName.charAt(0)}.` : "";
    return userTile;
  }
}
